function mobileButtons(){
    // mobile container slideToggle
    document.querySelectorAll('.header__mobile-button').forEach(btn => {
        btn.addEventListener('click', (event) => {
            // если кнопка раскрывает какое-либо меню
            if (btn.dataset.buttonName) {
                event.preventDefault();
                btn.classList.toggle('header__mobile-button_active');

                document.querySelectorAll('.header__mobile-button-container').forEach(container => {
                    if (btn.dataset.buttonName === container.dataset.buttonName) {
                        container.slideToggle(200);
                    }
                });
            }
        });
    });

    // focus on search
    const searchBtn = document.querySelector('.header__mobile-button[data-button-name="search"]');
    if(searchBtn){
        searchBtn.addEventListener('click', (e) => {
            const searchInput = document.querySelector('.header__mobile-button-container[data-button-name="search"] input[type="search"]');
            if(searchBtn.classList.contains('header__mobile-button_active')){
                searchInput.focus();
            } else {
                searchInput.blur();
            }
        });
    }
}

export default mobileButtons;